import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface Tour {
  id: string;
  name: string;
  description: string | null;
  is_active: boolean;
  target_page: string | null;
  created_at: string;
  updated_at: string;
}

export const useActiveTours = () => {
  return useQuery({
    queryKey: ['active-tours'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('tours')
        .select('*')
        .eq('is_active', true)
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return data as Tour[];
    }
  });
};